import { useState } from 'react';
export var useBoolean = function useBoolean() {
  var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var [state, setState] = useState(defaultValue);
  return [state, {
    on: () => setState(true),
    off: () => setState(false),
    toggle: () => setState(!state)
  }];
};
//# sourceMappingURL=useBoolean.js.map